import React, { type FunctionComponent } from 'react'
import returnAndEarnLogo from '../../../../images/returnAndEarnWhite.svg'
import cdsVicWestLogo from '../../../../images/cdsvicwest.svg'
import recycleRewardsLogo from '../../../../images/recyclerewards-logo.svg'

const stateSchemeMap: { [key: string]: string } = {
  RETURNANDEARN: returnAndEarnLogo,
  CDSVICWEST: cdsVicWestLogo,
  RECYCLEREWARDS: recycleRewardsLogo
}

type Props = {
  appContext: string
}

export const SchemeAppLogo: FunctionComponent<Props> = ({ appContext }) => {
  return (
    <div className="w-[3.3rem] h-[3.3rem] rounded overflow-hidden flex items-center justify-center ring-2 ring-fog bg-white">
      <img className="p-sm" src={stateSchemeMap[appContext]} alt={`${appContext} scheme logo`} />
    </div>
  )
}
